const CODE_TOKEN_PATTERN = /^[A-Za-z]{1,12}[-_]?\d{2,}$/;
const TRAILING_NUMERIC_ID_PATTERN = /(\d{3,})$/;

const idFromToken = token => {
  const cleaned = String(token || '').trim();
  if (!cleaned) return '';
  if (/^\d{3,}$/.test(cleaned) || CODE_TOKEN_PATTERN.test(cleaned)) {
    return cleaned;
  }

  return cleaned.match(TRAILING_NUMERIC_ID_PATTERN)?.[1] || '';
};

export const propertySearchQueryFromInput = value => {
  const raw = String(value || '').trim();
  if (!raw) return '';

  const keyValueMatch = raw.match(
    /(?:imovel|imóvel|property|house|codigo|código|code|id)[=/: -]+([A-Za-z0-9_-]{3,})/i
  );
  if (keyValueMatch?.[1]) return keyValueMatch[1];

  try {
    const url = new URL(raw);
    const queryKeys = [
      'id',
      'codigo',
      'code',
      'house_id',
      'houseId',
      'imovel_id',
      'imovelId',
      'property_id',
      'propertyId',
    ];
    const queryMatch = queryKeys
      .map(key => url.searchParams.get(key))
      .find(Boolean);
    if (queryMatch) return queryMatch;

    const pathMatch = decodeURIComponent(url.pathname)
      .split(/[^A-Za-z0-9_-]+/)
      .filter(Boolean)
      .reverse()
      .map(idFromToken)
      .find(Boolean);

    return pathMatch || raw;
  } catch {
    if (/[\s,]/.test(raw)) return raw;
    return idFromToken(raw) || raw;
  }
};
